export type CustomerDetailsRecurringReservationsTranslation = {
  add: string;
  columns: {
    conflicts: string;
    manager: string;
    name: string;
    period: string;
    resource: string;
    schedule: string;
  };
  empty: string;
  emptyRunning: string;
  heading: string;
  loadError: string;
  loading: string;
  rejectedCustomer: string;
  rowsPerPage: string;
  showEnded: string;
};

export const customerDetailsRecurringReservationsTranslation: CustomerDetailsRecurringReservationsTranslation =
  {
    add: 'Dodaj rezerwację stałą',
    columns: {
      conflicts: 'Do przełożenia',
      manager: 'Zarządzający',
      name: 'Nazwa',
      period: 'Okres',
      resource: 'Zasób',
      schedule: 'Harmonogram',
    },
    empty: 'Klient nie ma rezerwacji stałych.',
    emptyRunning: 'Klient nie ma aktywnych rezerwacji stałych.',
    heading: 'Rezerwacje stałe',
    loadError: 'Nie udało się wczytać rezerwacji stałych klienta.',
    loading: 'Wczytywanie rezerwacji stałych',
    rejectedCustomer: 'Odrzucony klient nie może mieć rezerwacji stałej.',
    rowsPerPage: 'Wierszy na stronie',
    showEnded: 'Pokaż zakończone',
  };
